import { MouseEventHandler } from 'react';
import { ArrowForward } from '@mos-cat/ds-icons';
import { SystemStyleObject } from '@styled-system/css';
import { Box } from '../../Box/Box';
import { UtilityButton } from '../../UtilityButton/UtilityButton';

import { useCalendarContext } from '../context';
import { CalendarNavigationType } from '../helpers';
import { NAVIGATION_KINDS } from '../constants';

export type NavigationButtonType = 'left' | 'right';

type Props = {
  type: NavigationButtonType;
  navigationType: CalendarNavigationType;
  onClick: (type: NavigationButtonType) => void;
};

export function NavigationButton({ type, navigationType, onClick }: Props) {
  const {
    leftNavigationButtonRef,
    rightNavigationButtonRef,
  } = useCalendarContext();
  const ref =
    type === 'left' ? leftNavigationButtonRef : rightNavigationButtonRef;

  const handleClick = () => {
    ref.current?.focus();
    onClick(type);
  };

  const handleMouseDown: MouseEventHandler = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };

  return (
    <UtilityButton
      ref={ref}
      as="button"
      type="button"
      aria-label={NAVIGATION_KINDS[type][navigationType]}
      onClick={handleClick}
      onMouseDown={handleMouseDown}
      styles={
        {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          size: 'calendarNavBtn',
          color: 'secondaryBtnText',
          p: 'sp-4',
          borderRadius: 'button',
          backgroundColor: 'secondaryBtnBg',
          borderColor: 'secondaryBtnBorder',
          ':hover': {
            backgroundColor: 'secondaryBtnHoverBg',
            borderColor: 'secondaryBtnBorder',
          },
          ':active': {
            backgroundColor: 'blue-30',
            borderColor: 'blue-30',
          },
        } as SystemStyleObject
      }
    >
      <Box
        as={ArrowForward}
        size="calendarNavIcon"
        styles={{
          ...(type === 'left' ? { transform: 'rotate(180deg)' } : {}),
        }}
      />
    </UtilityButton>
  );
}
